(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tbf-campaign-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tbf-campaign-products')) {
  customElements.define('tbf-campaign-products', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.cards = Array.from(this.querySelectorAll('[data-tbf-card]'));
      this.cards.forEach(card => {
        const select = card.querySelector('[data-tbf-variant]');
        if (select) select.addEventListener('change', () => { this.updateCard(card); this.updateSelection(); });
        const pick = card.querySelector('[data-tbf-pick]');
        if (pick) pick.addEventListener('change', () => this.updateSelection());
        this.updateCard(card);
      });
      this.updateSelection();
      this.addEventListener('click', event => {
        if (event.target.closest('[data-tbf-bundle]') && !this.querySelector('[data-tbf-items] input')) {
          event.preventDefault(); event.stopPropagation(); this.updateSelection();
        }
      });
    }
    option(card) { const select = card.querySelector('[data-tbf-variant]'); return select ? select.selectedOptions[0] : card.querySelector('[name="id"]'); }
    updateCard(card) {
      const option = this.option(card);
      if (!option) return;
      card.querySelector('[data-tbf-price]').textContent = option.dataset.money;
      const url = `${card.dataset.url}?variant=${option.value}`;
      card.querySelectorAll('[data-tbf-link]').forEach(link => { link.href = url; });
      const imageLink = card.querySelector('.tbf-campaign-products__image');
      imageLink.setAttribute('aria-label', `${card.dataset.title}, ${option.dataset.weight}`);
      const button = card.querySelector('[data-tbf-add]');
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      const buttonLabel = available ? button.dataset.tbfAddLabel : button.dataset.tbfUnavailableLabel;
      button.querySelector('[data-add-to-cart-text]').textContent = buttonLabel;
      button.setAttribute('aria-label', `${buttonLabel}: ${card.dataset.title}, ${option.dataset.weight}`);
      const servings = card.querySelector('[data-tbf-servings]');
      if (servings) servings.hidden = card.dataset.servingVariant !== option.value;
      const image = imageLink.querySelector('img');
      if (image && option.dataset.image && image.src !== option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
      const pick = card.querySelector('[data-tbf-pick]');
      if (pick) { pick.disabled = !available; if (!available) pick.checked = false; }
    }
    updateSelection() {
      const target = this.querySelector('[data-tbf-items]');
      if (!target) return;
      target.replaceChildren();
      let total = 0;
      let count = 0;
      this.cards.forEach(card => {
        if (!card.querySelector('[data-tbf-pick]')?.checked) return;
        const option = this.option(card);
        if (!option || option.dataset.available !== 'true') return;
        total += Number(option.dataset.price);
        for (const [key, value] of [['id', option.value], ['quantity', '1']]) {
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = `items[${count}][${key}]`; input.value = value; target.appendChild(input);
        }
        count += 1;
      });
      const summary = this.querySelector('[data-tbf-summary]');
      if (!this.emptySummary) this.emptySummary = summary.textContent;
      const currency = document.documentElement.getAttribute('lang') || 'en-GB';
      const amount = new Intl.NumberFormat(currency, { style: 'currency', currency: 'GBP' }).format(total / 100);
      summary.textContent = count ? `${count} ${count === 1 ? 'pack' : 'packs'} selected · ${amount}` : this.emptySummary;
      this.querySelector('[data-tbf-bundle]').disabled = count === 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbf-free-gift-popup"]) return;
  try {
    
  (() => {
    if (customElements.get('tbf-free-gift-popup')) return;

    const quantitiesByProduct = (cart) => {
      const quantities = new Map();
      for (const item of cart?.items ?? []) {
        const productId = Number(item.product_id);
        quantities.set(productId, (quantities.get(productId) ?? 0) + Number(item.quantity ?? 0));
      }
      return quantities;
    };

    const getIncreasedProductIds = (previousCart, currentCart) => {
      const previous = quantitiesByProduct(previousCart);
      const current = quantitiesByProduct(currentCart);
      return [...current.entries()]
        .filter(([productId, quantity]) => quantity > (previous.get(productId) ?? 0))
        .map(([productId]) => productId);
    };

    class TbfFreeGiftPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('[data-gift-form]');
        this.error = this.querySelector('[data-error]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.qualifyingProductIds = this.readIdSet('[data-qualifying-product-ids]');
        this.giftProductIds = this.readIdSet('[data-gift-product-ids]');
        this.previousFocus = null;
        this.cartPromise = this.fetchCart();
        this.onCartAdded = this.onCartAdded.bind(this);

        document.addEventListener('theme:cart:added', this.onCartAdded);
        this.form?.addEventListener('change', () => {
          this.submitButton.disabled = !this.form.querySelector('[type="radio"]:checked');
        });
        this.form?.addEventListener('submit', (event) => this.addGift(event));
        this.querySelector('[data-close]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-skip]')?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('theme:cart:added', this.onCartAdded);
      }

      readIdSet(selector) {
        try {
          return new Set(JSON.parse(this.querySelector(selector)?.textContent ?? '[]').map(Number));
        } catch (_error) {
          return new Set();
        }
      }

      async fetchCart() {
        const response = await fetch(this.dataset.cartUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      }

      promptKey(cart) {
        return `tbf-free-gift-prompted:${cart.token ?? 'current-cart'}`;
      }

      wasPrompted(cart) {
        try {
          return sessionStorage.getItem(this.promptKey(cart)) === 'true';
        } catch (_error) {
          return false;
        }
      }

      rememberPrompt(cart) {
        try {
          sessionStorage.setItem(this.promptKey(cart), 'true');
        } catch (_error) {
          // The popup still works when browser storage is unavailable.
        }
      }

      async onCartAdded() {
        try {
          const previousCart = await this.cartPromise;
          const currentCart = await this.fetchCart();
          this.cartPromise = Promise.resolve(currentCart);

          const increasedProductIds = getIncreasedProductIds(previousCart, currentCart);
          const qualifyingAdded = increasedProductIds.some((id) => this.qualifyingProductIds.has(id));
          const giftAlreadyInCart = currentCart.items.some((item) => this.giftProductIds.has(Number(item.product_id)));

          if (qualifyingAdded && !giftAlreadyInCart && !this.wasPrompted(currentCart)) {
            this.rememberPrompt(currentCart);
            this.open();
          }
        } catch (_error) {
          this.cartPromise = this.fetchCart();
        }
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.error.textContent = '';
        this.dialog.showModal();
      }

      close() {
        if (!this.dialog?.open) return;
        this.dialog.close();
        this.previousFocus?.focus?.();
      }

      setLoading(isLoading) {
        this.submitButton.disabled = isLoading;
        this.form.querySelectorAll('input, button').forEach((control) => {
          control.disabled = isLoading;
        });
        this.querySelector('[data-submit-label]').hidden = isLoading;
        this.querySelector('[data-loading-label]').hidden = !isLoading;
      }

      refreshCart() {
        if (typeof window.cart?.getCart === 'function') {
          window.cart.getCart();
          return;
        }

        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }

      async addGift(event) {
        event.preventDefault();
        const selected = this.form.querySelector('[type="radio"]:checked');
        if (!selected) return;

        this.error.textContent = '';
        this.setLoading(true);

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: [{ id: Number(selected.value), quantity: 1 }] }),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add gift');

          this.cartPromise = this.fetchCart();
          this.close();
          this.refreshCart();
        } catch (_error) {
          this.error.textContent = this.dataset.errorMessage;
          this.setLoading(false);
          this.submitButton.disabled = !this.form.querySelector('[type="radio"]:checked');
        }
      }
    }

    customElements.define('tbf-free-gift-popup', TbfFreeGiftPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
